<template>
  <page-container style="background-color:#fff;">
    <div style="background-color:#fff;padding:10px 0;">
      <div class="el-tabs el-tabs--card el-tabs--top">
        <div class="el-tabs__header is-top" style="margin:0;">
          <div class="el-tabs__nav-wrap is-top">
            <div class="el-tabs__nav-scroll">
              <div role="tablist" class="el-tabs__nav is-top" style="transform: translateX(0px);">
                <div v-for="tab in tabs" :key="tab.path" :class="['el-tabs__item', 'is-top', $route.path.indexOf(tab.path) >= 0 ? 'is-active' : '']" @click="goPath(tab.path)">{{ tab.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-view/>
  </page-container>
</template>

<script>
export default {
  data () {
    return {
      tabs: [
        { path: '/customer/company', title: 'Company' },
        { path: '/customer/group', title: 'Company Group' },
        { path: '/customer/report', title: 'Company Report' }
      ]
    }
  },
  methods: {
    goPath (path) {
      this.$router.replace(path)
    }
  }
}
</script>